export default "__VITE_ASSET__B2b90nd3__"